var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{class:_vm.inputClass,attrs:{"type":_vm.type,"required":_vm.required,"name":_vm.name,"id":_vm.id,"placeholder":_vm.placeholder},domProps:{"checked":_vm.checked}}),(_vm.label)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }